module.exports = __webpack_public_path__ + "img/candidate-purple.e0a6a135.png";